module.exports = {"description":"<h2 class=\"mb-2 text-2xl font-bold\">Welcome,</h2><p class=\"font-light text-gray-500\">This after-sales service declaration area will allow you to declare a problem, make an appointment to deal with it and consult the follow-up of your declaration.</p>","nouveau_sav":"New service report","je_souhaite_faire_une_nouvelle_declaration_de_sav":"I would like to make a new service report!","me_connecter":"Log in","je_possede_deja_un_compte":"I already have an account"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/default/en/home/welcome.lang.json
// module id = 2NTM
// module chunks = 1